import React from "react";
import styled from "styled-components";
import { mobileQuery } from "../MediaQuery";
import { ResponsiveLayout } from "../ResponsiveLayout";
import { SizedBox } from "../SizedBox";
import { Header3, Paragraph1 } from "../typography";
import { Section } from "./Section";

export const EvidenceBasedSection: React.FC = () => (
  <Section secondaryGradient>
    <Header3 color="white" center>
      EVIDENCE BASED HEALTHSPAN MODEL
    </Header3>
    <SizedBox height={48} />
    <ResponsiveLayout justifyContent="space-evenly" alignItems="center">
      <StatementBox title="550 000" subtitle="people clinically researched" />
      <SizedBox mobileHeight={32} />
      <StatementBox title="up to 15 yrs" subtitle="of health history" />
    </ResponsiveLayout>
    <SizedBox height={32} />
    <ResponsiveLayout justifyContent="space-evenly" alignItems="center">
      <StatementBox title="AI" subtitle="machine learning" />
    </ResponsiveLayout>
    <SizedBox height={64} />
    <Paragraph1 color="white" center>
      data sources include: UK Biobank, Centers for Disease Control and
      Prevention (USA)
    </Paragraph1>
  </Section>
);

const StatementBox: React.FC<{
  title: string;
  subtitle: string;
}> = (props) => (
  <StatementBoxWrapper>
    <StatementTitle>{props.title}</StatementTitle>
    <SizedBox height={8} />
    <StatementSubtitle>{props.subtitle}</StatementSubtitle>
  </StatementBoxWrapper>
);

const StatementBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;

  ${mobileQuery`
    width: 100%;
  `}
`;

const StatementTitle = styled.p`
  color: white;
  font-size: 72px;
  font-weight: 800;
  margin: 0px;
  ${mobileQuery`
    font-size: 42px;
  `}
`;

const StatementSubtitle = styled.p`
  color: white;
  font-size: 32px;
  font-weight: bold;
  margin: 0px;
  ${mobileQuery`
    font-size: 20px;
  `}
`;
